import React, { FC, useState, useEffect } from "react";
import { RouterParamType } from "@/model/navModel";
import { SupplierDialog } from "./SupplierDialog";
import { TableBox } from "./TableBox";
import { MaterialDiolog } from "./MaterialDialog";
import { useSupplierOfferModel } from "./supplierOfferModel";


export const Extract: FC<RouterParamType> = (detailsInfo) => {
    const { enquiryCode, setEnquiryCode } = useSupplierOfferModel(({ enquiryCode }) => [enquiryCode]);

    //每次进入tab页签  准确拿到对应询价单得code， 关闭得时候清空
    useEffect(() => {
        setEnquiryCode(detailsInfo.id);
        return () => {
            setEnquiryCode("")
        }
    }, [])
    return (
        <>
            {/* {enquiryCode && <> */}
            <TableBox {...detailsInfo} />
            <SupplierDialog {...detailsInfo} />
            <MaterialDiolog {...detailsInfo} />
            {/* </>} */}
        </>
    )
}